import { RECENT_PROMO_DAYS, PROMO_SCHEDULE_STATUS } from './promoScheduleConstants'
import { getKyivDateKey, subtractDaysFromDateKey } from './getKyivDateKey'
import isPromoScheduleActiveNow from './isPromoScheduleActiveNow'

export const getPromoScheduleStatus = (schedule, now = new Date()) => {
  if (!schedule || schedule.isActive === false) {
    return PROMO_SCHEDULE_STATUS.archived
  }

  const today = getKyivDateKey(now)
  const recentCutoff = subtractDaysFromDateKey(today, RECENT_PROMO_DAYS)
  const { startedAt, finishedAt, isArchived } = schedule

  if (isArchived === true) {
    if (!finishedAt || finishedAt < recentCutoff) {
      return PROMO_SCHEDULE_STATUS.archived
    }

    if (finishedAt < today) {
      return PROMO_SCHEDULE_STATUS.recent
    }
  }

  if (isPromoScheduleActiveNow(schedule, now)) {
    return PROMO_SCHEDULE_STATUS.active
  }

  if (startedAt && startedAt > today) {
    return PROMO_SCHEDULE_STATUS.upcoming
  }

  if (finishedAt && finishedAt < today && finishedAt >= recentCutoff) {
    return PROMO_SCHEDULE_STATUS.recent
  }

  return PROMO_SCHEDULE_STATUS.archived
}

export const isSelectablePromoSchedule = (schedule, now = new Date()) => {
  const status = getPromoScheduleStatus(schedule, now)

  return (
    status === PROMO_SCHEDULE_STATUS.active ||
    status === PROMO_SCHEDULE_STATUS.upcoming ||
    status === PROMO_SCHEDULE_STATUS.recent
  )
}

export default getPromoScheduleStatus
